<template>
  <BaseBody>
    <BaseTopBar>
      <BaseTopBarContent className="left">
        {{ $t('sidebar.journalentry') }} > {{ $t('sidebar.create') }}
      </BaseTopBarContent>
    </BaseTopBar>
    <BaseContent :loading="loading">
      <JournalEntryForm
        :jvCode="nextJvCode"
        :isSubmitted="isSubmitted"
        :disabled="disabled"
        :form.sync="form"
        :showActionButtons="true"
        @onSubmit="handleSubmit"
      />

      <BaseConfirmDiscardModal
        :show="confirmDiscardModal.show"
        @onCancel="handleDiscardCancleModal"
        @onConfirm="handleDiscardConfirmModal"
      />
    </BaseContent>
  </BaseBody>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import sidebarModule from './../../sidebarModule'
import _ from 'lodash'
import discardFormMixin from '@/mixins/discardForm'
import JournalEntryForm from '../../../combine/JournalEntryForm.vue'

export default {
  components: {
    JournalEntryForm,
  },
  mixins: [discardFormMixin],
  data () {
    return {
      loading: true,
      isSubmitted: false,
      disabled: false,
      form: null,
    }
  },
  computed: {
    ...mapGetters({
      nextJvCode: 'nextJvCode',
      accountSetting: 'getAccountSetting',
    }),
    defaultStatus() {
      return this.accountSetting.journal.entry_manual.default_status
    },
  },
  methods: {
    ...mapActions([
      'getNextCodeJournalEntries',
      'getAccountsListChartOfAccounts',
      'insertJournalEntries',
    ]),
    async handleSubmit(form) {
      this.isSubmitted = true
      this.disabled = true
      const payload = {
        'jv_type': form.jv_type,
        'description': form.description || null,
        'status': this.defaultStatus,
        'refs': [],
        'lines': form.lines.map((line) => {
          return {
            'account_type': line.account_type,
            'account_code': line.account_code,
            'label': line.label || null,
            'debit': Number(line.debit),
            'credit': Number(line.credit),
          }
        }),
      }
      const response = await this.insertJournalEntries({
        data: payload,
      })
      if (response.success) {
        this.isSubmitted = false
        this.disabled = false
        this.notify(this.$vs, {
          text: this.$t('message.hasbeencreated', { msg: response.data.jv_code }),
          color: 'success',
          icon: 'cloud',
        })
        this.$router.push({
          name: 'AccountsJournalEntryEdit',
          query: {
            jv_id: response.data._id,
            jv_code: response.data.jv_code,
            ignoreDiscardAlert: true,
          },
        })
      }
    },
  },
  async created () {
    await Promise.all([
      this.getNextCodeJournalEntries(),
      this.getAccountsListChartOfAccounts(),
    ])
    this.loading = false
    this.showFinish(this.$Progress)
  },
  beforeMount () {
    // init page
    this.initPage({
      section: 'app',
      name: this.$t('app.accounts.title'),
      current: {
        app_name: 'accounts',
        app_id: 12,
        module_id: 6,
      },
    })
    // set sidebar ui
    sidebarModule.init(this.getObject(require('../sidebar.json')), {
      sidebarAtIdx: 4,
      submenuAtIdx: 1,
    })
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/apps/accounts/journalentry/New.vue